import type { ElementType, KeyboardEvent } from 'react';

import { S } from './Card.styles';
import type { CardProps } from './Card.types';
import { CardContext } from './CardContext';

export const Card = <C extends ElementType = 'div'>({
  component,
  height,
  isInteractive,
  onClick,
  role,
  onKeyDown: onKeyDownFromProps,
  ...otherProps
}: CardProps<C>) => {
  const isAccessible = !!(onClick || isInteractive);

  const onKeyDown = onClick
    ? (event: KeyboardEvent<HTMLElement>) => {
        onKeyDownFromProps?.(event);
        if (event.defaultPrevented) return;
        if (!event.repeat && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          event.currentTarget.click();
        }
      }
    : onKeyDownFromProps;

  return (
    <CardContext value={{ height }}>
      <S.Container
        as={component}
        $height={height}
        $isInteractive={isInteractive}
        onClick={onClick}
        {...(isAccessible && {
          tabIndex: 0,
        })}
        {...(onClick && {
          role: role ?? 'button',
        })}
        onKeyDown={onKeyDown}
        {...otherProps}
      />
    </CardContext>
  );
};
